import { createContext, useReducer, useEffect } from "react";
import Cookies from "js-cookie";
import AuthReducer from "./AuthReducer";

const safeEncode = (str) => btoa(encodeURIComponent(str));
const safeDecode = (str) => decodeURIComponent(atob(str));

const INITIAL_STATE = {
  token_client: Cookies.get("token_client") || null,
  user_client: Cookies.get("user_client")
    ? JSON.parse(safeDecode(Cookies.get("user_client")))
    : null,
};

export const AuthContext = createContext(INITIAL_STATE);

export const AuthContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(AuthReducer, INITIAL_STATE);

  useEffect(() => {
    if (state.token_client) {
      Cookies.set("token_client", state.token_client, { expires: 7 });
    } else {
      Cookies.remove("token_client");
    }

    if (state.user_client) {
      Cookies.set(
        "user_client",
        safeEncode(JSON.stringify(state.user_client)),
        {
          expires: 7,
        }
      ); // Encode user as Base64
    } else {
      Cookies.remove("user_client");
    }
  }, [state.token_client, state.user_client]);

  return (
    <AuthContext.Provider
      value={{
        token_client: state.token_client,
        user_client: state.user_client,
        dispatch,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
